module.exports = __webpack_public_path__ + "img/powered_by_wegow_horizontal.b6673e77.png";